import { Routes, Route } from "react-router-dom"
import Simulation from "./pages/client/Simulation/Simulation"
import SimulationExam from "./pages/client/Simulation/SimulationExam"
import Login from './pages/admin/Login/Login';
import ExamList from './pages/admin/Exam/ExamList';
import ExamCreate from './pages/admin/Exam/ExamCreate';
import ExamQuestList from './pages/admin/Exam/ExamQuestList';
import ExamQuestEdit from './pages/admin/Exam/ExamQuestEdit';
import ExamQuestCreate from './pages/admin/Exam/ExamQuestCreate';
import SimulationAdmin from './pages/admin/Simulation/SimulationList';
import SimulationCreate from './pages/admin/Simulation/SimulationCreate';
import SimulationDetail from './pages/admin/Simulation/SimulationDetail';
import UserList from './pages/admin/User/UserList';
import UserCreate from './pages/admin/User/UserCreate';
import UserEdit from './pages/admin/User/UserEdit';
import Resource from './pages/admin/Resource/Resource';
import ResourceUpload from './pages/admin/Resource/ResourceUpload';
import Exam from './pages/client/Exam/Exam';
import Home from './pages/client/Exam/Home';
import SimulationExamList from './pages/admin/SimulationExam/SimulationList';
import SimulationExamCreate from './pages/admin/SimulationExam/SimulationCreate';
import SimulationExamDetail from './pages/admin/SimulationExam/SimulationDetail';
function App() {
  return (
    <Routes>
    <Route path="" element={<Home />} />
    <Route path="exam/:examId" element={<Exam />} />
    <Route path="simulation" element={<Simulation />} />
    <Route path="simulation/exam" element={ <SimulationExam/> } />

    <Route path="admin/login" element={ <Login/> } />
    <Route path="admin" element={ <ExamList/> } />
    <Route path="admin/exam" element={ <ExamCreate/> } />
    <Route path="admin/exam/:examId" element={ <ExamQuestList/> } />
    <Route path="admin/exam/:examId/quest/:questionId" element={ <ExamQuestEdit/> } />
    <Route path="admin/exam/:examId/quest" element={ <ExamQuestCreate/> } />

    <Route path="admin/simulation" element={ <SimulationAdmin/> } />
    <Route path="admin/simulation/create" element={ <SimulationCreate/> } />
    <Route path="admin/simulation/:simulationId" element={ <SimulationDetail/> } />

    <Route path="admin/simulation/exam" element={ <SimulationExamList/> } />
    <Route path="admin/simulation/exam/create" element={ <SimulationExamCreate/> } />
    <Route path="admin/simulation/exam/:examId" element={ <SimulationExamDetail/> } />

    <Route path="admin/user" element={ <UserList/> } />
    <Route path="admin/user/:userId" element={ <UserEdit/> } />
    <Route path="admin/user/owner/create" element={ <UserCreate/> } />
    <Route path="admin/resource" element={ <Resource/> } />
    <Route path="admin/resource/upload" element={ <ResourceUpload/> } />
  </Routes>
  )
}

export default App